import { loadScript, loadScripts } from '../script-registry';
import { ScriptLoadStrategy, ScriptProps } from '../types/types';

/**
 *
 * @param strategy
 * @param fn
 */
export function schedule(strategy: ScriptLoadStrategy, fn: () => void) {
    if (typeof window === 'undefined') {
        return fn();
    }

    switch (strategy) {
        case 'beforeInteractive':
        case 'afterInteractive':
            fn();
            return;
        case 'lazyOnload':
            if (document.readyState === 'complete') {
                fn();
            } else {
                window.addEventListener('load', fn, { once: true });
            }
            return;
        case 'idle':
            if ('requestIdleCallback' in window) {
                (window as any).requestIdleCallback(fn);
            } else {
                setTimeout(fn, 1);
            }
            return;
        default:
            fn();
    }
}

/** 단일 스크립트 */
export function runScript(props: ScriptProps, strategy: ScriptLoadStrategy) {
    return new Promise<void>((resolve, reject) => {
        schedule(strategy, () => {
            loadScript(props).then(resolve).catch(reject);
        });
    });
}

export function runScripts(scripts: ScriptProps[], strategy: ScriptLoadStrategy) {
    const list = scripts.map((s) => ({ strategy, async: false, ...s }));

    return loadScripts(list);
}
